import type { IcIcon } from "./types";

export const IcChevronRight: IcIcon = (properties) => (
  <svg
    display="block"
    height="1.5em"
    viewBox="0 0 13 22"
    width="1.5em"
    xmlns="http://www.w3.org/2000/svg"
    {...properties}
  >
    <path
      d="M0 19.05 8.081 11 0 2.95 2.46.5 13 11 2.46 21.5z"
      fill="currentColor"
    />
  </svg>
);
